import api from './api'

export const getClientConfig = () =>
  api()
    .url(`/v1/${process.env.VUE_APP_DEVICE}/client/configuration`)
    .get()
